import type { ChangeEventHandler, MouseEventHandler } from "react"

interface CheckoutDiscountCodeProps {
  discountCode: string
  discountCodeError: string | null
  onEnterDiscountCode: ChangeEventHandler<HTMLInputElement>
  onSubmitDiscountCode: MouseEventHandler<HTMLButtonElement>
}
export default function CheckoutDiscountCode({
  discountCode,
  discountCodeError,
  onEnterDiscountCode,
  onSubmitDiscountCode,
}: CheckoutDiscountCodeProps) {
  return (
    <>
      <p className="mb-1 text-sm text-red">{discountCodeError}</p>
      <div className="mt-1 flex rounded-sm">
        <div className="relative flex items-stretch flex-grow focus-within:z-10">
          <input
            className="border border-gray-300 block w-full rounded-none rounded-l-md p-2"
            id="discountCode"
            name="discountCode"
            onChange={onEnterDiscountCode}
            placeholder="Enter discount code"
            type="text"
            value={discountCode}
          />
        </div>
        <button
          className="-ml-px relative font-browser inline-flex items-center space-x-2 px-8 py-2 border border-gray-300 text-sm font-medium rounded-r-sm text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none"
          onClick={onSubmitDiscountCode}
          type="button"
        >
          <span>Apply</span>
        </button>
      </div>
    </>
  )
}
